module.exports = __webpack_public_path__ + "static/img/door-0.ac743fa2.png";